import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, HostListener, SimpleChange, ViewChild, OnDestroy } from '@angular/core';
import { Globals } from '../objects/Globals';
import { ActivatedRoute, Router } from '@angular/router';
import { SummaryService } from '../services/summary.service';
import { Summary, SummarySortOption, SummaryPage } from '../objects/SummaryObject';
import { WorkspaceService } from '../services/workspace.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { ConfirmationService } from '../services/confirmation.service';
import { ToasterMessageService } from '../services/toaster-message.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent implements OnInit, OnDestroy {

  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;

  selectedItemId:string;
  sortDirectionIsAscending:boolean = true;
  sortOptions:SummarySortOption[];
  selectedSortOption:SummarySortOption;
  selectedSortValue: string;
  pageSize:string;
  private currentPage:number;
  currentPageChange:number;
  private availablePages:number;
  private totalRows:number;
  nextPageDummy:boolean;
  prevPageDummy:boolean;
  private smallSum: boolean = false;
  forceRefresh:boolean;
  private rangeWithDots: any[];
  sortOrder: string;
  private sortOptionType: string;
  private onMobile: boolean;
  private currentParentId: string;
  changeSummaryLayout: string = '';
  private subscription: Subscription;
  private subscription1: Subscription;

  isDualView: boolean;
  isCardView: boolean = true;
  fetching : boolean = false;
  summaryName: string;
  showInputCombo: boolean;
  enableSearch: boolean = false;

  @Input() documentType:string;
  @Input() documentSummaryName:string;
  @Input() parentType:string;
  @Input() parentId:string;
  @Input() set setSelectedDetailId(id:string){ this.selectedItemId = id;}
  @Input() keyword:string = '';
  @Input() customInput:string;
  @Input() componentId:string;
  @Input() showPagination : boolean = true;
  @Input() hidePanel: boolean = false;
  @Input() inputComboFilter: string;
  @Output() selectedId = new EventEmitter<string>();
  @Output() selectedCardId = new EventEmitter<string>();
  @Output() selectedType = new EventEmitter<string>();
  @Output() updateParent = new EventEmitter<boolean>();
  @Output() updateTotalRows = new EventEmitter<number>();
  @Output() toggleSummary = new EventEmitter<boolean>();
  @Output() setSummaryName = new EventEmitter<string>();
  @Output() keywordChanged = new EventEmitter<string>();

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 992) {
      if (this.smallSum){
        this.onMobile = true;
      }
    }
    else{
      this.onMobile = false;
    }
  }

  selectedSortOptionSortField(){
    if(this.selectedSortOption){
      return this.selectedSortOption.SortField;
    }else{
      return null;
    }
  }
  onSelectedItem(selectedId:string) {
    this.selectedId.emit(selectedId);
    this.onMobile = window.innerWidth < 992;
    this.smallSum = true;
  }
  onSelectedType(selectedType:string) {
    this.selectedType.emit(selectedType);
  }

  onSelectedCardId(selectedId: string){
    this.selectedCardId.emit(selectedId);
    this.onMobile = true;
  }

  changeLayout(isCardView:boolean, type: string){
    if (isCardView != this.isCardView){
      this.changeSummaryLayout = type;
    }
  }

  onSearchOptionsChange(sortOptions:SummarySortOption[]){
    this.sortOptions = sortOptions;
    
    this.summaryService.getCurrentSort(this.componentId).subscribe(result=>{
      var sortedField = result.split('|')[0];
      var sortedIsAsc = result.split('|')[1];
      if (this.sortOptions.find(x=> x.SortField == sortedField)){
        this.selectedSortValue = this.sortOptions.find(x=> x.SortField == sortedField).SortOptionDisplay;
        this.sortOptionType = this.sortOptions.find(x=> x.SortField == sortedField).SortOptionType;
      }
      this.sortDirectionIsAscending = (sortedIsAsc.toLowerCase() == "true");
      this.formatSortOrder();
    })
    
  }
  onFilterChanged(selectedOption:string){
    this.selectedSortOption = this.sortOptions.find(x=> x.SortField == selectedOption);
    this.sortOptionType = this.selectedSortOption.SortOptionType;
    
  }
  onChangeSortDirection(){
    if (this.sortOrder == "A-Z"){
      this.sortOrder = "Z-A";
    } else if (this.sortOrder == "Z-A"){
      this.sortOrder = "A-Z";
    } else if (this.sortOrder == "Newest"){
      this.sortOrder = "Oldest";
    } else if (this.sortOrder == "Oldest"){
      this.sortOrder = "Newest";
    }
    this.sortDirectionIsAscending = !this.sortDirectionIsAscending;
  }

  onCurrentPageChange(currentPage:number){
    this.currentPageChange = currentPage;
  }

  onSummaryPageChange($event:SummaryPage){
    this.currentPage = $event.currentPage;
    this.availablePages = $event.availablePage;
    this.pagination(this.currentPage, this.availablePages);
  }

  onSummaryTotalRowsChange(totalRows:number){
    this.totalRows = totalRows;
    this.updateTotalRows.emit(this.totalRows);
  }

  changePagingSize(pageSize:string){
    this.pageSize = pageSize;
  }

  previousPage(){
    this.prevPageDummy = !this.prevPageDummy;
  }
  nextPage(){
    this.nextPageDummy = !this.nextPageDummy;
  }

  switchSummary(){
    this.onMobile = false;
    //this.toggleSummary.emit(true);
  }

  forceSummaryRefresh(event){
    this.forceRefresh = !this.forceRefresh;
  }

  updateParentControl(event){
    this.updateParent.emit(event);
  }

  setSummary($event){
    this.summaryName = $event;
    this.setSummaryName.emit($event);
  }

  formatSortOrder(){
    switch(this.sortOptionType){
      case "TEXT" :
      default:
        if(this.sortDirectionIsAscending){
          this.sortOrder = "A-Z";
        }else{
          this.sortOrder = "Z-A";
        }
      break;
      case "DATE" :
        if(this.sortDirectionIsAscending){
          this.sortOrder = "Oldest";
        }else{
          this.sortOrder = "Newest";
        }
      break;
      case "NUMBER" :
        this.sortOrder = "" 
      break;
    }
  }

  pagination(currentPage, pagesNo) {
    var delta = 2,
        range = [],
        l;

    this.rangeWithDots = [];

    range.push(1);

    if (pagesNo <= 1) {
        return range;
    }

    for (let i = currentPage - delta; i <= currentPage + delta; i++) {
        if (i < pagesNo && i > 1) {
            range.push(i);
        }
    }
    range.push(pagesNo);

    for (let i of range) {
        if (l) {
            if (i - l === 2) {
                this.rangeWithDots.push(l + 1);
            } else if (i - l !== 1) {
              this.rangeWithDots.push('...');
            }
        }
        this.rangeWithDots.push(i);
        l = i;
    }
    //return rangeWithDots;
  }

  public onContextMenu($event, item: any): void {
    if($event.button == 0){
      this.contextMenuService.show.next({
        anchorElement: $event.target,
        contextMenu: this.basicMenu,
        event: $event,
        item: item,
      });
    }
    $event.preventDefault();
    $event.stopPropagation();
  }

  saveSetting(){
    var sortBy = "ascending";
    if (!this.sortDirectionIsAscending) sortBy = "descending";

    this.confirmationService.confirm(
      "Save current sorting as my default?",
      "<p>Do you want to save the sorting of \"" + this.selectedSortValue + "\" in " + sortBy + " order as my default for this list?</p>",
      ["NO", "YES"], false)
      .subscribe((respond) => {
        if (respond.answer == "YES"){
          this.summaryService.saveCurrentSummarySortLayout(this.componentId).subscribe(result => {
            if (result == "1"){
              this.toasterMessageService.popToast("Info", "Your default sorting has been updated", "info")
            }
          })
        }
    });
  }

  constructor(private route:ActivatedRoute, private globals:Globals, private summaryService:SummaryService, private router:Router, private workspaceService: WorkspaceService, 
    private contextMenuService: ContextMenuService, private confirmationService: ConfirmationService, private toasterMessageService: ToasterMessageService) {
      this.subscription = this.workspaceService.currentParentIdChanged$.subscribe(id => {
        if (this.componentId == id){
          this.forceRefresh = !this.forceRefresh;
        }
      });
      
      this.subscription1 = this.summaryService.enableSearchChanged$.subscribe(result => {
        if(!result) result = false;
        this.enableSearch = result;
      })
   }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
    if (this.subscription1) this.subscription1.unsubscribe();
  }

  ngOnInit() {
    if(this.componentId && this.globals.Session){
      this.summaryService.getCurrentSearchKeyword(this.componentId).subscribe(result=>{
        if(result){
          this.keyword = result;
        }
      })
    }
  }

}
